export default function SectionHeading({ eyebrow, title, subtitle, align = "left", testIdBase }) {
  const isCenter = align === "center";
  return (
    <div className={`mb-14 ${isCenter ? "text-center mx-auto max-w-2xl" : ""}`}>
      {eyebrow && (
        <div data-testid={testIdBase ? `${testIdBase}-eyebrow` : undefined} className="eyebrow mb-5">
          {!isCenter && <span className="gold-line" />}
          {eyebrow}
          {isCenter && <span className="gold-line ml-3" />}
        </div>
      )}
      <h2
        data-testid={testIdBase ? `${testIdBase}-title` : undefined}
        className="section-title text-4xl md:text-5xl lg:text-6xl font-semibold text-monarch-cream text-balance leading-[1.05]"
      >
        {title}
      </h2>
      {subtitle && (
        <p
          data-testid={testIdBase ? `${testIdBase}-subtitle` : undefined}
          className={`mt-5 text-monarch-ash text-base md:text-lg leading-relaxed ${isCenter ? "" : "max-w-xl"}`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
